const kollator = new Intl.Collator('de', { sensitivity: 'base' })

// rangSortierung.js
export function vergleicheRang(a, b) {
  const d = (Number(b.value) || 0) - (Number(a.value) || 0)
  if (Math.abs(d) > 1e-9) return d                                   // Punkte absteigend
  return (Number(a.ranking) || 0) - (Number(b.ranking) || 0)         // Serverreihenfolge = Nachname, Vorname
}